export const apiConfig = {
  baseUrl: process.env.REACT_APP_BASE_URL_PROVIDER
};
